const dateTokens = ['YYYY', 'MM', 'DD', 'HH', 'mm', 'ss'] as const

type DateFormatToken = (typeof dateTokens)[number]

const DATE_TOKEN_REGEX = new RegExp(dateTokens.join('|'), 'g')

// If shorter than maxLength, pad with leading zeros until it reaches maxLength
const pad = (n: number, maxLength = 2) => String(n).padStart(maxLength, '0')

// This could be slightly optimized, but unless it becomes a real issue,
// it's still quite cheap and  more readable and maintainable to create the token map
const createTokenMap = (date: Date): Record<DateFormatToken, string> => ({
  YYYY: String(date.getFullYear()),
  MM: pad(date.getMonth() + 1),
  DD: pad(date.getDate()),
  HH: pad(date.getHours()),
  mm: pad(date.getMinutes()),
  ss: pad(date.getSeconds()),
})

export const formatDateToString = (date?: Date, format = 'YYYY-MM-DD') => {
  if (!date) {
    return ''
  }

  const tokenMap = createTokenMap(date)

  return format.replace(DATE_TOKEN_REGEX, (matched) => tokenMap[matched as DateFormatToken])
}
